<template>
    <div class="form form__price">
        <label
            v-if="label"
            :for="name | toKebabCase"
            class="form__price_title"
        >{{label | toCapitalize}}<span class="asterisk" v-if="required">*</span></label>
        <div class="columns columns--customLine is-variable is-2">
            <div class="column columns--customLine--break is-narrow">
                <label
                    class="form__price_currency"
                    :for="name | toKebabCase"
                >{{ $t('forms.price') }}</label>
            </div>
            <div class="column">
                <input
                    ref="placeholder"
                    class="form__price_input"
                    type="text"
                    :id="name | toKebabCase"
                    :value="valueFormatted"
                    @focus="focusNumeric"
                >
                <input
                    ref="numeric"
                    :disabled="disabled"
                    type="text"
                    class="form__price_input hidden"
                    :id="name | toKebabCase"
                    :name="name | toKebabCase"
                    :value="value"
                    @input="newValue"
                    @blur="newValueReformat"
                    v-validate="vValidate"
                    :data-vv-as="dataVvAs ? dataVvAs : label.toLowerCase()"
                >
            </div>
        </div>
        <span
            class="form__error form__price_error"
            v-if="errors.first(toKebabCase(name))"
        >{{ errors.first(toKebabCase(name)) }}</span>
        <template v-if="$slots.default">
            <div class="form__price_hint">
                <slot></slot>
            </div>
        </template>
    </div>
</template>

<script>
import AutoNumeric from 'autonumeric'
import { toKebabCase } from '@/functions'

export default {
  name: 'form-price',
  data () {
    return {
      autonumeric: '',
      valueFormatted: '',
      preventRegenerate: false
    }
  },
  props: {
    name: {
      type: String,
      required: true,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    //
    dataVvAs: {
      type: String,
      default: ''
    },
    vValidate: {
      default: ''
    }
  },
  watch: {
    value (newValue, oldValue) {
      this.autonumeric.set(this.value)
      this.valueFormatted = this.autonumeric.getFormatted()
      if (!this.preventRegenerate) {
        this.renderValue()
        this.regenerateValue()
      }
    }
  },
  mounted () {
    const self = this
    this.autonumeric = new AutoNumeric(this.$refs.numeric)
    this.renderValue()
    this.regenerateValue()
    this.$refs.numeric.onfocus = function () {
      self.regenerateValue()
      self.$refs.placeholder.classList.add('hidden')
      self.$refs.numeric.classList.remove('hidden')
    }
    this.$refs.numeric.onblur = function () {
      self.regenerateValue()
      self.$refs.placeholder.classList.remove('hidden')
      self.$refs.numeric.classList.add('hidden')
    }
  },
  methods: {
    emitFocus () {
      const field = this.$validator.errors.items.find(obj => obj.field === toKebabCase(this.name))
      this.$validator.pause()
      if (field) {
        this.$validator.reset(field)
      }
      this.$emit('emit-focus')
    },
    emitBlur () {
      const field = this.$validator.errors.items.find(obj => obj.field === toKebabCase(this.name))
      this.$validator.resume()
      if (field) {
        this.$validator.reset(field)
      }
      this.$emit('emit-blur')
    },
    regenerateValue () {
      this.autonumeric.setValue(this.value / 100)
      this.autonumeric.reformat()
    },
    renderValue () {
      setTimeout(() => {
        this.autonumeric.reformat()
        this.valueFormatted = this.autonumeric.getFormatted()
      }, 1)
    },
    focusNumeric () {
      this.preventRegenerate = true
      this.$refs.numeric.focus()
    },
    newValue: function () {
      let value
      if (typeof event === 'number' || typeof event === 'string') {
        value = event
      } else {
        value = event.target.value
      }
      this.$emit('input', value)
    },
    newValueReformat (event) {
      this.autonumeric.reformat()
      let value = this.autonumeric.getFormatted()
      this.$emit('input', Number(value.replace(/[,.-]/g, '')))
      this.renderValue()
    }
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formprice";
</style>
